import Box from 'assets/components/box/Box';
import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import usePageRouter from 'assets/hooks/pageRouter/usePageRouter';
import { getLocales } from 'assets/locales/Locale';
import ThemeWrapperStack from 'assets/themes/wrappers/Theme.Wrapper.Stack';
import { vehicleModelIndexRoute } from '../../vehicleModel/VehicleModel.Index';
import { VehicleMakeAction, useVehicleMakeProvider } from '../VehicleMake.Hooks';
import { combineStrings } from 'assets/utils/data/String';

export default function VehicleMakeList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = useVehicleMakeProvider();

  const { redirect: redirectToModels } = usePageRouter<
    Module.ProductManagement.VehicleModel.Params,
    Module.ProductManagement.VehicleModel.Query
  >({
    route: vehicleModelIndexRoute,
  });
  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.vehicles}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.makeCode}</th>
          <th>{lang.tiers}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: vehicleMake }) => (
            <tr key={vehicleMake.id}>
              <td>
                <b>{vehicleMake.makeCode}</b>
              </td>{' '}
              <td>{vehicleMake.tiers?.map((it) => combineStrings(' - ', it.name))?.join(', ')}</td>
              <td>
                <Box class={ThemeWrapperStack}>
                  <Button
                    onClick={() =>
                      redirectToModels(null, { makeId: vehicleMake.id, list: { makeCode: vehicleMake.makeCode } })
                    }
                    disabled={!permissions.EDIT_VEHICLEMODEL}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-plus" />}
                    htmlElementProps={{ title: `${lang.add} ${lang.vehicleModel}` }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: vehicleMake.id.toString(),
                      action: VehicleMakeAction.EDIT,
                    }}
                    disabled={!permissions.EDIT_VEHICLEMAKE}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-edit" />}
                    htmlElementProps={{ title: lang.edit }}
                    active
                  />
                  <Button
                    onClick={pageRouter.updateParams}
                    data={{
                      id: vehicleMake.id.toString(),
                      action: VehicleMakeAction.DELETE,
                    }}
                    disabled={!permissions.DELETE_VEHICLEMAKE}
                    class={ThemeButtonCircle}
                    media={<Icon class="fas-trash" />}
                    htmlElementProps={{ title: lang.delete }}
                    active
                  />
                </Box>
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
